import { transition } from '@helpers/animate';
import brand from '@helpers/brand';
import { fluid } from '@helpers/fluid';
import { ButtonReset } from '@helpers/global';
import { rgba } from 'polished';
import styled from 'styled-components';
const Button = styled.button `
  ${ButtonReset}

  --size: ${fluid(32, 42)};

  display: flex;
  background: ${rgba(brand.white, 0.5)};
  border-radius: 50%;
  color: ${brand.black};
  height: var(--size);
  place-content: center;
  place-items: center;
  ${transition('background-color, color')};
  width: var(--size);

  &[data-active='true'],
  &.focus-ring,
  &:hover {
    background-color: ${rgba(brand.black, 0.35)};
    color: ${brand.white};
  }

  &[data-active='true'] {
    &.focus-ring,
    &:hover {
      background-color: ${rgba(brand.black, 0.5)};
      color: ${brand.white};
    }
  }

  svg {
    display: block;
    height: ${fluid(18, 26)};
    width: ${fluid(18, 26)};
  }

  @media print {
    display: none;
  }
`;
const PinButtonStyles = {
    Button,
};
export default PinButtonStyles;
